// extracted by mini-css-extract-plugin
export default {"form":"UpdateRiskRegisterForm_form__UCyNB"};